import { Component, OnInit } from '@angular/core';
import { ServiceBase } from '../services-base/service.base.class';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'kts-engineering',
  templateUrl: './../services-base/service.base.template.html',
  styleUrls: ['./../services-base/serivce.base.styles.scss']
})
export class EngineeringComponent extends ServiceBase implements OnInit {

  title = 'Engineering';
  contents = [
    {
      subTitle: 'Our Engineering Services Include:',
      textcontents: [
        'Electrical Hardware Design',
        'Engineering Design & Modification of Fixtures, Manipulation Systems & Spot Guns',
        'Production Layout Design & Planning',
        'Project Management & Planning',
        'Structure Design',
        'Welding Engineering & Development',
        'Engineering Investigations'],
      imagePath: '/enginering/1.jpg'
    }, {
      subTitle: 'Our Mechanical Engineering Department Specialises in:',
      textcontents: [
        '- Fixture, Robot Gripper & Machine Design',
        '- Sheet Metal & Plastic Injection Tool Molding & Die Design',
        '- Machine Modification & Automation',
        '- Mechanical Installation & Commissioning',
        '- Project Planning & Management',
        '- FE Stress Analysis & Process Simulation',
        '- Weld Gun Design',
        '- Engineering Investigations & Consultation'],
      imagePath: '/enginering/2.jpg'
    }, {
      subTitle: 'Our Electrical Engineering Department Specialises in:',
      textcontents: [
        '- Medium & High Tension Electrical System Design & Installation',
        '- Switchgear Implementation',
        '- Design & Planning Of Electrical Installations',
        '- Fault Finding Analysis',
        '- Installation & Commissioning',
        '- COC Signoff On Electrical Designs & Installations',
        '- Transfer Systems',
        '- Electrical Distribution System Design',
        '- Electrical Panel Building & Design'],
      imagePath: '/enginering/3.jpg'
    }];
    constructor(meta: Meta, title: Title) {
        super();
        title.setTitle('Engineering Services | Katiso Engineering and Automation');

        meta.updateTag(
            {
                name: 'keywords', content: 'Katiso Engineering, Automotive Supplier, engineering, electrical, mechanical, modification, production, design, planning, project management, structure, welding, automation'
            }
            )
        meta.updateTag(
            {
                name: 'description', content: 'Electrical Hardware Design. Engineering Design & Modification of Fixtures, Manipulation Systems & Spot Guns. Production Layout Design & Planning. Project Management & Planning. Structure Design. Welding Engineering & Development. Engineering Investigations. | Katiso Engineering and Automation'
            }
        )
    
    }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/services/engineering/engineering.component.ts